import * as API from "middleware/api";

export const getListFrequentDestinations = (params) => API.executeWithAccessToken("/destinations.list", { ...params });

export const getDetailFrequentDestinations = (params) =>
    API.executeWithAccessToken("/destinations.detail", { ...params });

// export const getListFrequentDestinations = (params) => ({ data: frequentDestinations });
export const createDestinationPreview = (cbu, recipientEmail, name, validateOnlyCbu) =>
    API.executeWithAccessToken("/destinations.create.preview", {
        cbu,
        recipientEmail,
        name,
        validateOnlyCbu,
    });

export const createDestination = (params) =>
    API.executeWithAccessToken("/destinations.create", {
        ...params,
    });

// export const createDestination = (params) => ({ data: createSuccessMock, status: 200 });

export const dowloadFrequentDestinations = () =>
    API.executeWithAccessToken("/frequentDestinations.exportFrequentDestinations");

export const deleteFrequentDestinationPreview = (params) =>
    API.executeWithAccessToken("destinations.delete.preview", { ...params });

export const deleteFrequentDestinationRequenst = (params) =>
    API.executeWithAccessToken("destinations.delete", {
        ...params,
    });

export const modifyFrequentDestinationPre = (id) =>
    API.executeWithAccessToken("/destinations.modify.pre", { idFrequentDestination: id });

export const modifyFrequentDestinationPreview = (params) =>
    API.executeWithAccessToken("/destinations.modify.preview", {
        ...params,
    });

export const modifyFrequentDestination = (params) =>
    API.executeWithAccessToken("destinations.modify", {
        ...params,
    });

export const createFrequentDestinationTransferPre = (params) =>
    API.executeWithAccessToken("frequentdestinations.transfer.create.pre", {
        cbu: params.cbuAlias,
    });
export const downloadDestinations = (params) =>
    API.executeWithAccessToken("destination.downloadDestination", {
        ...params,
    });
